import type { ServiceFaq } from "@/components/seo/ServiceIntentPage";

const BASE_URL = "https://adkiro.com";

interface ServicePageSeoInput {
  path: string;
  title: string;
  description: string;
  serviceName: string;
  serviceType: string;
  audience: string[];
  faqs: ServiceFaq[];
}

export function servicePageHead({
  path,
  title,
  description,
  serviceName,
  serviceType,
  audience,
  faqs,
}: ServicePageSeoInput) {
  const pageUrl = `${BASE_URL}${path}`;

  return {
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:url", content: pageUrl },
      { property: "og:type", content: "website" },
      { property: "og:image", content: `${BASE_URL}/logo.png?v=20260907` },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
    ],
    links: [{ rel: "canonical", href: pageUrl }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Service",
              "@id": `${pageUrl}#service`,
              name: serviceName,
              serviceType,
              url: pageUrl,
              description,
              provider: { "@id": `${BASE_URL}/#organization` },
              areaServed: ["United States", "Europe", "United Arab Emirates"],
              audience: audience.map((name) => ({ "@type": "BusinessAudience", name })),
            },
            {
              "@type": "BreadcrumbList",
              itemListElement: [
                { "@type": "ListItem", position: 1, name: "Home", item: `${BASE_URL}/` },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Services & pricing",
                  item: `${BASE_URL}/meta-ads-pricing`,
                },
                { "@type": "ListItem", position: 3, name: serviceName, item: pageUrl },
              ],
            },
            {
              "@type": "FAQPage",
              mainEntity: faqs.map((faq) => ({
                "@type": "Question",
                name: faq.q,
                acceptedAnswer: { "@type": "Answer", text: faq.a },
              })),
            },
          ],
        }),
      },
    ],
  };
}
